import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { URL_BASE } from '../../core/constants';
import { PathSearchCriteria } from '../path-search-criteria.model';
import { map } from 'rxjs/operators';
import { Path } from '../path.model';
import { HttpUtils } from '../http-utils';

@Injectable()
export class RoutePathService {

  private ROUTE_PATH_URI = 'routing/route-path';

  constructor(private http: HttpClient) {
  }

  public search(criteria: PathSearchCriteria): Observable<Path> {
    const headers = HttpUtils.createHeaders();

    return this.http.get(`${URL_BASE}/api/${this.ROUTE_PATH_URI}/search`, { headers, params: criteria.toHttpParams() })
      .pipe(
        map((result: any) => Path.fromDto(result))
      );
  }

  public searchForCustomer(customerId: string, criteria: PathSearchCriteria): Observable<Path> {
    const headers = HttpUtils.createHeaders();

    return this.http.get(`${URL_BASE}/api/${this.ROUTE_PATH_URI}/for-customer-trip/${customerId}`, { headers, params: criteria.toHttpParams() })
      .pipe(
        map((result: any) => Path.fromDto(result))
      );
  }
}
